const modalHtml = require("../../../../sharedHtml/modal.html");
const modalBodyHtml = require("./html/modalBody.html");
const boxDimRowHtml = require("./html/boxDimRow.html");
import _ from "underscore";
import {setElementsFromScope, handleDisplayForV2, combineElements, setOptionsForSelect} from "../../../../utilities/selectorHelpers";
import render from "../../../../utilities/render";
require("./ShipFedExModal.less");
import $ from "jquery";
let singleton;


export default function shipFedExModalFactory(options){
  if(singleton){
    // singleton.setOptions(options);
    return singleton;
  }
  else{
    singleton = new ShipFedExModal(options);
    singleton.init();
    return singleton;
  }
}

const noop = (()=>{});




const elementsMap = {
  closeBtn: ".close-btn",
  topCloseBtn: ".top-close-btn",
  shipFedExBtn: ".ship-fedex-btn",
  boxDimRowsOuter: ".box-dim-rows-outer",
  addBoxBtn: ".sf-add-box-btn",
  shareShipCheckbox: ".share-ship-info-checkbox",
  form: ".modal-form",
  shipFedexAddressDropdown: ".ship-fedex-addr-dropdown"
}



function ShipFedExModal(options={}){
  const self = this;
  let done;
  self._element = $();
  const els = {};
  let validator;

  self.init = function(){
    setHtml();
    setElements();
    pouplateAddressDropdown();
    attachToBody();
    setValidator();
    setWidgets();
    bindElements();
    renderUpdate();
  }

  self.getElement = getElement;
  self.showModal = showModal;
  self.getAllFormData = getAllFormData;

  function getElement(){
    return self._element;
  }

  function pouplateAddressDropdown(){
    setOptionsForSelect({
      selectElement: els.shipFedexAddressDropdown,
      list: $("#order-detail-page").data("addresses"),
      initialSelectValue: "",
      valueDataKey: "cadId",
      textDataKey: "cadLocationName"
    });
  }

  function setValidator(){
    validator = els.form.validate({
      errorPlacement: function(error, element) {
        let appendClosest = $(element).data('error-placement-append-closest');
        if (appendClosest) {
          $(element).closest(appendClosest).append(error);
        } else {
          error.insertAfter(element);
        }
      }
    });
  }

  function setHtml(){
    self._element = $(render(
      modalHtml,
      {
        modalDialogClass: "modal-lg",
        topCloseBtn: true,
        title: "Shipping with FedEx",
        subtitle: "Provide box dimensions and weight to generate a shipping label.",
        body: render(modalBodyHtml),
        footerBtns: `
          <a href="#" class="base-btn purple-btn v2-btn close-btn">Cancel</a>
          <a href="#" class="base-btn purple-btn ship-fedex-btn">Ship With FedEx</a>
        `
      }
    ));
  }

  function setElements(){
    setElementsFromScope(els, elementsMap, getElement());
  }

  function attachToBody(){
    $('body').append(getElement());
  }

  function renderUpdate(){
    renderChildren();
    updateSelf();
  }

  function updateSelf(){
    updateIdxs();
    updateRemoveBtns();
  }

  function renderChildren(){
    const bdrsHtml = _([{length: 5, width: 10, height: 20, weight: 30}]).map(renderBoxDimRow);
    els.boxDimRowsOuter.html(bdrsHtml);
  }

  function updateRemoveBtns(){
    const allRemoveBtns = getBoxDimRows().find(".remove-btn");
    handleDisplayForV2(allRemoveBtns, true);

    handleDisplayForV2(allRemoveBtns.first(), allRemoveBtns.length > 1);
  }

  function updateIdxs(){
    getBoxDimRows().each(updateRowIdx);
  }

  function updateRowIdx(idx){
    const row = $(this);
    const idxEl = row.find(".bdr-idx");
    idxEl.text(idx + 1);
  }

  function renderBoxDimRow(bdrData={}){
    return render(boxDimRowHtml,
      {
        ...bdrData,
        lengthId: _.uuid(),
        widthId: _.uuid(),
        heightId: _.uuid(),
        weightId: _.uuid()
      }
    );
  }

  function addBoxDimRow(bdrData={}){
    const bdrHtml = renderBoxDimRow(bdrData);
    els.boxDimRowsOuter.append(bdrHtml);
  }

  function setWidgets(){
    getElement().modal({backdrop: 'static', show: false});
  }

  function bindElements(){
    combineElements([els.closeBtn, els.topCloseBtn]).on("click", onCloseBtnClick);
    els.shipFedExBtn.on("click", onShipFedExBtnClick);
    els.addBoxBtn.on("click", onAddBoxClick);
    els.boxDimRowsOuter.on("click", ".remove-btn", onRemoveRowClick);
  }

  function onRemoveRowClick(e){
    e.preventDefault();
    const row = $(this).closest(".box-dim-row");
    removeRow(row);
    updateSelf();
  }

  function removeRow(row){
    row.remove();
  }


  function onAddBoxClick(e){
    e.preventDefault();
    addBoxDimRow();
    updateSelf();
  }

  function onCloseBtnClick(e){
    e.preventDefault();
    console.log("close clicked");
    hideModal();
  }

  function onShipFedExBtnClick(e){
    e.preventDefault();
    console.log("ship with fed btn clicked");
    if(isModalValid()){
      options.onShipFedExBtnValidClick && options.onShipFedExBtnValidClick();
      hideModal();
    }
  }

  function getAllFormData(){
    const data = {};
    data.addressId = els.shipFedexAddressDropdown.val();
    data.boxes = _(getBoxDimRows().toArray()).map(collectRowData);
    data.shareShippingInfoWithChannel = els.shareShipCheckbox.is(":checked");
    return data;
  }

  function collectRowData(row){
    row = $(row);
    const data = {};
    data.length = row.find(".box-length").val();
    data.width = row.find(".box-width").val();
    data.height = row.find(".box-height").val();
    data.weight = row.find(".box-weight").val();
    return data;
  }

  function isModalValid(){
    return els.form.valid();
  }

  function getAllRowInputs(){
    return els.boxDimRowsOuter.find("input");
  }

  function getBoxDimRows(){
    return els.boxDimRowsOuter.find(".box-dim-row");
  }

  function showModal(){
    getElement().modal("show");
  }

  function hideModal(){
    getElement().modal("hide");
  }
}



// WEBPACK FOOTER //
// ./src/pages/order/components/shipFedExModal/shipFedExModal.js